import { Pipe, PipeTransform } from '@angular/core';
import { QuantifiedProcedure } from '@rivethealth/data/estimation';

@Pipe({ name: 'procedureList' })
export class ProcedureListPipe implements PipeTransform {
  transform(procedures: QuantifiedProcedure[]): string {
    return procedures
      .map(procedure =>
        [procedure.code, procedure.modifier, `(${procedure.quantity})`]
          .filter(Boolean)
          .join(' '),
      )
      .join(', ');
  }
}
